<template>
<notice-container>
    <modal-confirm v-model="modalConfirm.check" @confirm="modalConfirm.resolve" @canceled="modalConfirm.reject" :confirmLabel="modalConfirm.confirm" :cancelLabel="modalConfirm.cancel"  :title="modalConfirm.title">
        <div v-html="modalConfirm.message"></div>
    </modal-confirm>
    <modal-alert v-model="modalAlert.check" :okayLabel="modalAlert.okay" :title="modalAlert.title">
        <div v-html="modalAlert.message"></div>
    </modal-alert>
    <toast ref='toast'></toast>
</notice-container>
</template>

<script>
import { backfill, backfillData, registerModalReceiver } from '../../components/utils/globals';
import VueToast from './items/toast.vue';

export default {
	components: {
		Toast: VueToast,
		ModalConfirm: () => import('./items/modal-confirm.vue'),
		ModalAlert: () => import('./items/modal-alert.vue'),
		Sec: () => import('./containers/section.vue'),
	},
    data: backfillData({
        modalConfirm: {
            check: false,
            confirm: '',
            cancel: '',
            message: '',
            title: '',
            resolve(){},
            reject(){}
        },
        modalAlert: {
            check: false,
            type: '',
            okay: '',
            message: '',
            title: '',
        },
    }),
    methods: {

    },
    created() {
        let {modalConfirm,modalAlert,$refs} = this;
		registerModalReceiver({type:'confirm',receiver(receiverModel){
			Object.assign(modalConfirm,{...receiverModel,check:true});
		}});
		registerModalReceiver({type:'alert',receiver(receiverModel){
			Object.assign(modalAlert,{...receiverModel,check:true});
        }});
        registerModalReceiver({type:'toast',receiver({message,theme}){
			$refs.toast.showToast(message,{theme});
		}});
    }
};
</script>